import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
  width: 100%;
  position: relative;
`;

const Element = styled.div`
  position: relative;
  padding: 0px 16px;
  margin: 0 auto;
  width: 100%;
  max-width: 500px;
`;

export default function Holder({ children, color, height }) {
  return (
    <Wrap
      style={{ background: color ? color : "", minHeight: height ? height : 0 }}
    >
      <Element>{children}</Element>
    </Wrap>
  );
}
